import { Controller } from "@hotwired/stimulus"

const FULLSCREEN_LAYOUT_CLASSES = [
  "fixed",
  "inset-0",
  "z-[10000]",
  "h-dvh",
  "w-screen",
  "max-h-none",
  "rounded-none",
  "bg-black",
  "object-contain"
]

// Android Hotwire only: video covers the viewport and native chrome is hidden.
// iOS and web keep the default inline player (playsinline).
export default class extends Controller {
  connect () {
    if (!this.isAndroidNativeApp()) return

    this.enabled = true
    this.spotlightActive = false
    this.onPlay = this.enterSpotlight.bind(this)
    this.onEnded = this.exitSpotlight.bind(this)
    this.onCloseClick = this.exitSpotlight.bind(this)

    this.element.addEventListener("play", this.onPlay)
    this.element.addEventListener("ended", this.onEnded)
  }

  disconnect () {
    if (!this.enabled) return

    this.exitSpotlight()
    this.element.removeEventListener("play", this.onPlay)
    this.element.removeEventListener("ended", this.onEnded)
  }

  enterSpotlight () {
    if (this.spotlightActive) return

    this.spotlightActive = true
    this.hideChrome()
    this.applySpotlightStyles()
  }

  exitSpotlight () {
    if (!this.spotlightActive) return

    this.spotlightActive = false
    this.removeSpotlightStyles()
    this.showChrome()

    if (!this.element.paused && !this.element.ended) {
      this.element.pause()
    }
  }

  applySpotlightStyles () {
    this.element.classList.remove("object-cover", "object-center")
    this.element.classList.add(...FULLSCREEN_LAYOUT_CLASSES)
    document.documentElement.classList.add("video-spotlight-active")
    document.body.classList.add("overflow-hidden")

    this.closeButton = document.createElement("button")
    this.closeButton.type = "button"
    this.closeButton.setAttribute("aria-label", "Cerrar")
    this.closeButton.className =
      "fixed top-[max(0.75rem,env(safe-area-inset-top))] right-[max(0.75rem,env(safe-area-inset-right))] z-[10001] " +
      "inline-flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-white"
    this.closeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>'
    this.closeButton.addEventListener("click", this.onCloseClick)
    document.body.appendChild(this.closeButton)
  }

  removeSpotlightStyles () {
    this.element.classList.remove(...FULLSCREEN_LAYOUT_CLASSES)
    this.element.classList.add("object-cover", "object-center")
    document.documentElement.classList.remove("video-spotlight-active")
    document.body.classList.remove("overflow-hidden")

    this.closeButton?.removeEventListener("click", this.onCloseClick)
    this.closeButton?.remove()
    this.closeButton = null
  }

  hideChrome () {
    if (this.chromeEl) return

    this.chromeEl = document.createElement("div")
    this.chromeEl.setAttribute("data-controller", "bridge--tab-visibility")
    this.chromeEl.setAttribute("data-bridge--tab-visibility-tabbar-value", "false")
    this.chromeEl.setAttribute("data-bridge--tab-visibility-navbar-value", "false")
    document.body.appendChild(this.chromeEl)
  }

  showChrome () {
    this.chromeEl?.remove()
    this.chromeEl = null
  }

  isAndroidNativeApp () {
    return (
      document.documentElement.dataset.hotwireNative === "true" &&
      /Android\//i.test(navigator.userAgent)
    )
  }
}
